import microuniversoApi from "app/api/microuniversoApi"
import { sobrescreverInformacoesAction } from "app/redux/orcamentoSlice"
import store from "app/redux/store/store"
import { IOrcamento } from "app/types/IOrcamento"
import * as atualizacaoOrcamentoLegadoActions from 'app/redux/atualizacaoOrcamentoLegadoSlice'


import globalMU from "globalMU"

declare var window:any

export type DefinirValorFreteInput = {
    valorFrete: number
}

export type DefinirPercentualFreteInput = {
    percentual: number
}

export async function definirValorFrete(input: DefinirValorFreteInput) {
    
    try {
        globalMU.blockUI()
        
        const orcamentoAtualizado = await microuniversoApi.Orcamento.definirValorFrete(
            store.getState().orcamento.IdentificadorOrcamento,
            input.valorFrete
        )
 
        const atualizarEstado = () => {
            const orcamentoLegado = window.orcamentoController.model

            orcamentoLegado.atualizar(orcamentoAtualizado, true, true)

            store.dispatch(atualizacaoOrcamentoLegadoActions.atualizar(orcamentoAtualizado))

            store.dispatch(sobrescreverInformacoesAction({Indicador: orcamentoAtualizado.Indicador}))
        }
        atualizarEstado()
    } finally {
        globalMU.unblockUI()
    }
}

export async function definirPercentualFrete(input: DefinirPercentualFreteInput) { // 445689
    try {
        globalMU.blockUI()
        const orcamentoAtualizado = await microuniversoApi.Orcamento.definirPercentualFrete(
            store.getState().orcamento.IdentificadorOrcamento,
            input.percentual
        )
        const atualizarEstado = () => {
            const orcamentoLegado = window.orcamentoController.model
            orcamentoLegado.atualizar(orcamentoAtualizado, true, true)
            store.dispatch(atualizacaoOrcamentoLegadoActions.atualizar(orcamentoAtualizado))
        }
        atualizarEstado()
    } finally {
        globalMU.unblockUI()
    }
}